import * as React from 'react'
import * as ReactDOM from 'react-dom'
import * as mapboxgl from 'mapbox-gl'
import { MapContextProvider, Setup, useMapContext } from './context'

export type MarkerProps = {
  className?: string
  options: Omit<mapboxgl.MarkerOptions, 'element'> & { lngLat: mapboxgl.LngLatLike }
  children?: React.ReactNode
  popup?: React.ReactNode
}

export function Marker({ className, popup, options, children }: MarkerProps) {
  const { push, registered, pop } = useMapContext()
  const id = React.useId()

  const container = React.useMemo(() => {
    const container = document.createElement('div')
    return container
  }, [])

  React.useEffect(() => {
    className && container.setAttribute('class', className)
  }, [className])

  React.useEffect(() => {
    const marker = new mapboxgl.Marker({
      ...options,
      element: children ? container : undefined,
    })

    marker.setLngLat(options.lngLat)

    push(({ map }) => {
      marker.addTo(map)

      return { id, value: marker }
    })

    return () => {
      marker.remove()
      pop(id)
    }
  }, [])

  return (
    <MapContextProvider value={{ push: markerPush, registered, pop }}>
      {popup}
      {ReactDOM.createPortal(<>{children}</>, container)}
    </MapContextProvider>
  )

  function markerPush(setup: Setup) {
    push(({ map }) => {
      const entry = registered.get(id)
      if (entry === undefined) {
        throw Error('error')
      }
      if (!(entry instanceof mapboxgl.Marker)) {
        throw Error('error')
      }
      return setup({ map, marker: entry })
    })
  }
}
